/**
 * O ⌘K que FAZ, e não só o que leva.
 *
 * Quatro comandos que abrem um diálogo SOBRE a tela atual, em vez de navegar até
 * a tela que tem o botão. "Criar um contato" custava: sair do que se estava
 * fazendo, achar Contatos no menu, achar o botão, criar, e voltar de memória.
 * Aqui custa ⌘K e uma palavra — e a barra de endereço continua onde estava.
 *
 * `run` em vez de `to` é a diferença inteira: um destino é uma string que o
 * router entende, uma ação é um efeito na tela de quem chamou. Quem sabe qual
 * diálogo abrir é o `QuickCreate`; este arquivo só nomeia os quatro e diz quem
 * pode ver cada um.
 */
export type QuickCreateKind = "contact" | "pipeline" | "agent" | "conversation";

export interface PaletteAction {
	readonly kind: QuickCreateKind;
	/** Chaves, e não frases: quem sabe o idioma é a paleta, na hora de desenhar. */
	readonly labelKey: string;
	readonly hintKey: string;
	readonly run: () => void;
}

/**
 * Os dois sinais que decidem quem vê o quê, entregues de fora.
 *
 * `admin` porque `POST /v3/agents` é `@MinRole("admin")` — um comando que 403 é
 * pior do que comando nenhum. `hasSendableChannel` porque abrir uma conversa sem
 * canal que envie é uma caixa de texto que não sai daqui.
 */
export interface PaletteAccess {
	readonly admin: boolean;
	readonly hasSendableChannel: boolean;
}

export function paletteActions(
	access: PaletteAccess,
	open: (kind: QuickCreateKind) => void,
): PaletteAction[] {
	const all: Array<{ allowed: boolean; action: PaletteAction }> = [
		{
			allowed: true,
			action: {
				kind: "contact",
				labelKey: "palette.actions.contact.label",
				hintKey: "palette.actions.contact.hint",
				run: () => open("contact"),
			},
		},
		{
			allowed: true,
			action: {
				kind: "pipeline",
				labelKey: "palette.actions.pipeline.label",
				hintKey: "palette.actions.pipeline.hint",
				run: () => open("pipeline"),
			},
		},
		{
			allowed: access.hasSendableChannel,
			action: {
				kind: "conversation",
				labelKey: "palette.actions.conversation.label",
				hintKey: "palette.actions.conversation.hint",
				run: () => open("conversation"),
			},
		},
		{
			allowed: access.admin,
			action: {
				kind: "agent",
				labelKey: "palette.actions.agent.label",
				hintKey: "palette.actions.agent.hint",
				run: () => open("agent"),
			},
		},
	];
	return all.filter((row) => row.allowed).map((row) => row.action);
}
